var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5858 2H11C8.79086 2 7 3.79086 7 6H6C3.79086 6 2 7.79086 2 10V18C2 20.2091 3.79086 22 6 22H13C15.2091 22 17 20.2091 17 18H18C20.2091 18 22 16.2091 22 14V6.41421C22 6.149 21.8946 5.89464 21.7071 5.70711L18.2929 2.29289C18.1054 2.10536 17.851 2 17.5858 2ZM15 18H11C8.79086 18 7 16.2091 7 14V8H6C4.89543 8 4 8.89543 4 10V18C4 19.1046 4.89543 20 6 20H13C14.1046 20 15 19.1046 15 18Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/iconCopy.e92636da46105f44668bafbaba5dcef4.svg";
export { ForwardRef as ReactComponent };